import React from 'react';
import { Link } from 'react-router-dom';
import { CirclePointerIcon } from '../Home.style';
import {
  MemberBenefitContainer,
  MemberBenefitRow,
  MemberShipBackground,
  MemberShipButton,
  MemberShipContainer,
  MemberShipContent,
} from './Membership.style';

const buttonMotion = {
  hover: {
    scale: 1.01,
    boxShadow: '0px 4px 16px rgba(77, 100, 126, 0.4)',
    transition: { duration: 0.5 },
  },
};

const Membership = () => {
  return (
    <MemberShipBackground>
      <MemberShipContainer>
        <MemberShipContent>
          <h2>Our Memberships</h2>
          <h3>INTRODUCING AN EVEN MORE FLEXIBLE WAY TO TRAVEL</h3>
          <MemberBenefitContainer>
            <MemberBenefitRow>
              <h5>Enjoy Benefits such as:</h5>
            </MemberBenefitRow>
            <MemberBenefitRow>
              <span>24/7 Concierge</span>
              <span>Chauffeur Service</span>
            </MemberBenefitRow>
            <MemberBenefitRow>
              <span>Discounted Flights</span>
              <span>Exclusive Member Benefits</span>
            </MemberBenefitRow>
            <MemberBenefitRow>
              <span>Complimentary In-flight Amenities</span>
              <span>And much more!</span>
            </MemberBenefitRow>
          </MemberBenefitContainer>
        </MemberShipContent>

        <Link to={'/membership'}>
          <MemberShipButton whileHover="hover" variants={buttonMotion}>
            Get to know Membership
            <CirclePointerIcon $size={24} />
          </MemberShipButton>
        </Link>
      </MemberShipContainer>
    </MemberShipBackground>
  );
};

export default Membership;
